import React, {Fragment} from 'react';

import ClientDropdown from './navigation/clientDropdown';
import { useAuth0 } from './auth';
import { setClient, getClient } from '../common/authHelper';


const SuperUserToolbar = () => {

    const {user} = useAuth0();
    const selectedClient = getClient(user);

    const onSelect = (selectedClient) => {
        setClient(user, selectedClient);
        window.location.reload();
    };

    return (
        <Fragment>
            <div className="search-label-container"><span className="label">Select client: </span></div>
            <div className="search-input-container">
                <ClientDropdown onSelect={onSelect} selectedClient={selectedClient}/>
            </div>
        </Fragment>
    );
};

export default SuperUserToolbar;
